$(function() {
    'use strict';
});

